import { render, staticRenderFns } from "./Plane.vue?vue&type=template&id=76c89ad8&scoped=true"
import script from "./Plane.vue?vue&type=script&lang=js"
export * from "./Plane.vue?vue&type=script&lang=js"
import style0 from "./Plane.vue?vue&type=style&index=0&id=76c89ad8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c89ad8",
  null
  
)

export default component.exports